import { createContext, useContext, useMemo } from "react"
import { defaultProgramGuideConfig, resolveProgramGuideTheme } from "config/programGuideThemes"

const ProgramGuideThemeContext = createContext(defaultProgramGuideConfig)

const NO_OVERRIDE = {}

export function ProgramGuideThemeProvider({ site, themeOverride = NO_OVERRIDE, children }) {
    // Memoized so consumers (every session card) are not re-rendered whenever the guide renders.
    const merged = useMemo(() => {
        const siteOverride = resolveProgramGuideTheme(site)
        return {
            ...defaultProgramGuideConfig,
            sectionHeading:  { ...defaultProgramGuideConfig.sectionHeading,  ...siteOverride.sectionHeading,  ...themeOverride.sectionHeading },
            filterPanel:     { ...defaultProgramGuideConfig.filterPanel,     ...siteOverride.filterPanel,     ...themeOverride.filterPanel },
            dayPills:        { ...defaultProgramGuideConfig.dayPills,        ...siteOverride.dayPills,        ...themeOverride.dayPills },
            filterDropdowns: { ...defaultProgramGuideConfig.filterDropdowns, ...siteOverride.filterDropdowns, ...themeOverride.filterDropdowns },
            sessionList:     { ...defaultProgramGuideConfig.sessionList,     ...siteOverride.sessionList,     ...themeOverride.sessionList },
            sessionCard:     { ...defaultProgramGuideConfig.sessionCard,     ...siteOverride.sessionCard,     ...themeOverride.sessionCard },
            sessionDetail:   { ...defaultProgramGuideConfig.sessionDetail,   ...siteOverride.sessionDetail,   ...themeOverride.sessionDetail },
        }
    }, [site, themeOverride])

    return <ProgramGuideThemeContext.Provider value={merged}>{children}</ProgramGuideThemeContext.Provider>
}

export function useProgramGuideTheme() {
    return useContext(ProgramGuideThemeContext)
}
